
import '../../css/NotFound.css'
//Translation
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NotFound({ isNavOpen }) {
  
  const navigate = useNavigate();
    const { t } = useTranslation();

  return (
    <div className={`${isNavOpen ? 'body-squeezed' : 'body'}`}>
      <div className="not-found">
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.message')}</p>
      </div>
    </div>
    
  )
}